module.exports = __webpack_public_path__ + "img/b7d9097c039f2dd46a120ac8ed2fb032.9ee81616.png";